import React from 'react'

export default function Details({name,desc}) {
  return <div className="details">
      <h1>{name}</h1>
      <p className='muted-text'>{desc}</p>
  </div>;
}

